export default "__VITE_ASSET__8D52w1Yu__"